import React from 'react';
import { MdHelpOutline, MdInfo } from 'react-icons/md';
import { Tooltip as TooltipReact } from 'react-tooltip';

import styles from './tooltip.module.scss';

interface TooltipProps {
	/**
	 * Title to show on the tooltip content
	 */
	title: string;
	/**
	 * Text to show on the tooltip content
	 */
	text?: string;
	/**
	 * Text to show on the tooltip content as HTML
	 */
	htmltext?: React.ReactElement;
	/**
	 * Id of the tooltip as a reference for the element that will trigger the tooltip
	 */
	id?: string;
	/**
	 * Custom styles of the separator
	 */
	customStyles?: string;
}

export const Tooltip = ({ title, text, htmltext, customStyles, id }: TooltipProps) => {
	return (
		<div className={[styles['wrapper'], customStyles].join(' ')}>
			<div className={styles['icon']}>
				<MdHelpOutline size={24} data-tooltip-id={id} tabIndex={-1} />
			</div>
			<TooltipReact id={id} className={styles['content']}>
				<div>
					<div className={styles['title']}>
						<MdInfo size={24} className={styles['title-icon']} />
						<span>{title}</span>
					</div>
					<div className={styles['text']}>
						{text}
						{htmltext}
					</div>
				</div>
			</TooltipReact>
		</div>
	);
};
